/**
 * Flag to capture the state of validation for different sections
 */
export enum ShopifyValidation {
    NONE = 0, // 0000
    FIRST_PAGE = 1 << 0, // 0001
    SECOND_PAGE = 1 << 1, // 0010
    THIRD_PAGE = 1 << 2, // 0100
    FOURTH_PAGE = 1 << 3, // 1000
}

/**
 * Syntactic sugar for the annoying way you need to validate bitwise flags
 * @param currentValue The current enum value containing the flags
 * @param flag A flag to validate against
 * @returns If this flag is present
 */
export const checkShopifyFlag = (currentValue: ShopifyValidation, flag: ShopifyValidation) =>
    (currentValue & flag) === flag;

/**
 * Checks whether all of the flags are set to 1 (valid)
 * @param currentValue The current enum value containing the flags
 * @param numberOfPages number of pages (or flags) to validate
 * @returns true if the current value has all flags set to 1
 */
export const checkAllShopifyFlags = (currentValue: ShopifyValidation, numberOfPages: number) =>
    currentValue === ~(~0 << numberOfPages);

type ShopifyPaymentGateway = string;
type BankAccountIsMissing = boolean;
export type ShopifySetupBankAccountDeleted = Record<ShopifyPaymentGateway, BankAccountIsMissing>;
export type SetShopifySetupBankAccountDeleted = React.Dispatch<React.SetStateAction<ShopifySetupBankAccountDeleted>>;
export type PaymentGatewayBankAccountDeletedState = [ShopifySetupBankAccountDeleted, SetShopifySetupBankAccountDeleted];
